
import { graphql as gql } from 'react-relay';
const graphql = gql;

export const selectedCurrency = graphql`
  fragment selectedCurrency_viewer on Viewer {
    selected_currency
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/selectedCurrency.ts